import axios from "axios";
const API = axios.create({ baseURL: "https://api.scoriva.net/api" });

export const productApi = {
  getAll: () => API.get("/products"),
  get: (id) => API.get(`/products/${id}`),
  getImageUrl: (id) => `${API.defaults.baseURL}/products/${id}/image`,
};
